module.exports = __webpack_public_path__ + "static/media/daily-menu-item-availability.b5c44a1c.svg";